import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {useHistory} from "react-router-dom";

import {toggleShowAssignQuotePopup} from "../../../actions/assignPopupFunctions";
import WithOverlay from "../withOverlayHoc";
import AssignQuotePopupContent from "./assignQuotePopupContent";
import AssignQuotePopupNewCustomer from "./assignQuotePopupNewCustomer";
import AssignQuotePopupSaveButtons from "./assignQuotePopupSaveButtons";
import {CONTENT_TYPES} from "./assignQuoteConstants";
import AssignPopupContext, {initialContext} from './assignPopupContext';
import Config from "../../../config";
import AgreeEmailCheckbox from "../../common/agreeEmailCheckbox";

import goToMaterialPage from "../../common/goToMaterialPage";
import {setCameFromPage, toggleBathroomVisualizerOpen} from "../../../actions/actionFunctions";
import AssignQuoteContractSelection from "./assignQuoteContractSelection";
import {getLocalStorageItem, setLocalStorageItem} from "../../../misc/storageFunctions";
import {setContractsList} from "../../../actions/contractsActions";
import AssignQuotePopupTopButtons from "./assignQuotePopupTopButtons";


const AssignQuotePopup = (props) => {

  const {toggleShowAssignQuotePopup, showAssignQuotePopup, assignQuotePopupSaveButtons, cameFromPage, setCameFromPage,
    toggleBathroomVisualizerOpen, fabricatorData, setContractsList, contractsList} = props;

  const [contentType, setContentType] = useState(CONTENT_TYPES.searchCustomer);
  const [context, setContext] = useState(initialContext);
  const history = useHistory();

  if (!showAssignQuotePopup) {
    return null
  }

  const isContractSelect = contentType === CONTENT_TYPES.contractSelect;

  const closePopup = () => {
    toggleShowAssignQuotePopup(false);
    setContentType(CONTENT_TYPES.searchCustomer);
  };

  const changeContent = (nextContentType) => {
    setContentType(nextContentType);
    setContext({...context, customerError: "", lastContentType: contentType});
  };

  const saveContract = () => {
    setContractsList(contractsList.map(contract => {
      contract.selected = context.selectedContracts.includes(contract.id);
      return contract
    }));
    changeContent(context.lastContentType || CONTENT_TYPES.newCustomer); // go back
    const savedContracts = getLocalStorageItem("activeContracts") || {};
    savedContracts[document.kvConfig.userId || "noFabUser"] = context.selectedContracts;
    setLocalStorageItem("activeContracts", JSON.stringify(savedContracts));
  };

  const updateInputValidations = () => {
    setContext({...context, inputsValidated: false});
    return new Promise((resolve) => {
      setTimeout(() => {
        setContext({...context, inputsValidated: false});
        resolve()
      }, 300); // wait until redux store is updated with input Errors
    });
  };

  const changeContext = (newContextValues) => {
    setContext({...context, ...newContextValues});
  };

  const handleBackClick = (hideOverlay) => {
    if (isContractSelect) {
      changeContent(context.lastContentType || CONTENT_TYPES.newCustomer) // go back
    } else if (contentType === CONTENT_TYPES.searchCustomer) {
      hideOverlay(closePopup);
      if (assignQuotePopupSaveButtons === "updateTax") {
        switch (cameFromPage) {
          case 'visualizer':
            toggleBathroomVisualizerOpen(true);
            history.push('visualizer');
            break;
          case 'quote-design':
            history.push('quote-design');
            break;
          case 'materials':
          default: {
            goToMaterialPage("shoppingcart", false);
            break;
          }
        }
        setCameFromPage('');
      }
    } else {
      changeContent(CONTENT_TYPES.searchCustomer) // switch content back
    }
  };

  const agreeEmailCheckboxVisible = (Config.isDevMode() || document.kvConfig.isBackend) && !isContractSelect;
  const hideEmployeesList = document.kvConfig.jobId && fabricatorData.useIMEAPI
    && fabricatorData.useIMEAPI_PartnerId === 33; //hide to prevent creating new jobs on employee change

  return (
    <WithOverlay closePopup={closePopup}>
      {(hideOverlay) => (
        <AssignPopupContext.Provider value={context} setContext={setContext}>
          <div className="ui-popup ass-popup">
            <div className="bordered flex h-3 text-center w-full pl-125 pr-125">
              <span className="ui-popup__header-title">
                <FormattedMessage id={
                  contentType === CONTENT_TYPES.searchCustomer
                    ? hideEmployeesList ? "assignPopup.titleNoEmployee" : "assignPopup.title"
                    : contentType === CONTENT_TYPES.contractSelect
                      ? "assignPopup.assignContract"
                      : "assignPopup.newCustomer.title"
                }/>
              </span>
            </div>
            <AssignQuotePopupTopButtons changeContent={changeContent} contentType={contentType}/>
            <div className="ui-popup__body">
              <AssignQuotePopupContent isActive={contentType === CONTENT_TYPES.searchCustomer}
                                       hideEmployeesList={hideEmployeesList}
                                       changeContext={changeContext}/>
              <AssignQuotePopupNewCustomer isActive={contentType === CONTENT_TYPES.newCustomer}/>
              {fabricatorData.settings.useContractSigning ? <AssignQuoteContractSelection isActive={isContractSelect}
                                                                                 selectedContracts={context.selectedContracts}
                                                                                 changeContext={changeContext}/> : null}
            </div>
            <div className={"ui-popup__footer" + (agreeEmailCheckboxVisible ? " ui-popup__footer--with-sides" : "")}>
              {agreeEmailCheckboxVisible ? (
                <div className="ui-popup__footer-left">
                  <AgreeEmailCheckbox/>
                </div>
              ) : null}
              <div className="ui-popup__footer-right nowrap">
                <button className="selection-footer-buttons__button selection-footer-buttons__button--prev"
                        onClick={() => handleBackClick(hideOverlay)}>
                  <FormattedMessage id="assignPopup.backButton"/>
                </button>
                {isContractSelect ? (
                  <button className="ui-button2 ui-button2--green" onClick={saveContract}>
                    <FormattedMessage id="buttons.save"/>
                  </button>
                ) : (
                  <AssignQuotePopupSaveButtons closePopup={hideOverlay.bind(this, closePopup)}
                                               updateInputValidations={updateInputValidations}
                                               changeContext={changeContext}
                                               contentType={contentType}/>
                )}
              </div>
            </div>
          </div>
        </AssignPopupContext.Provider>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {showAssignQuotePopup, assignQuotePopupSaveButtons} = store.assignQuoteState;
  const {cameFromPage} = store.cartState;
  const {contractsList} = store.contractSigningState;

  return {
    showAssignQuotePopup,
    assignQuotePopupSaveButtons,
    cameFromPage,
    fabricatorData: store.fabricatorState,
    contractsList,
  };
};

const mapDispatchToProps = {
  toggleShowAssignQuotePopup,
  setCameFromPage,
  toggleBathroomVisualizerOpen,
  setContractsList,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopup)
)
